module.exports = __webpack_public_path__ + "img/icon-5-white.6f0edc36.png";